var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable } from 'mobx';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { APIData } from '../../../api/APIData';
import { cachedSet } from '../../../../utils/mobx/decorators/customComputed';
import { QuestionPassState_New } from '../../../question/passStates/states/QuestionPassState_New';
import { QuestionPassState_Wrong } from '../../../question/passStates/states/QuestionPassState_Wrong';
import { QuestionPassState_PartialCorrect } from '../../../question/passStates/states/QuestionPassState_PartialCorrect';
import { QuestionPassState_Blocked } from '../../../question/passStates/states/QuestionPassState_Blocked';
import { QuestionPassState_Skipped } from '../../../question/passStates/states/QuestionPassState_Skipped';
import { QuestionPassState_Passed } from '../../../question/passStates/states/QuestionPassState_Passed';
import { QuestionPassState_CorrectAfterWrong } from '../../../question/passStates/states/QuestionPassState_CorrectAfterWrong';
import { QuestionPassState_Passed2 } from '../../../question/passStates/states/QuestionPassState_Passed2';
import { QuestionPassState_Passed3 } from '../../../question/passStates/states/QuestionPassState_Passed3';
import { QuestionPassState_Phase1 } from '../../../question/passStates/states/QuestionPassState_Phase2';
import { QuestionPassState_Phase2 } from '../../../question/passStates/states/QuestionPassState_Phase1';
import { QuestionPassState_Phase3 } from '../../../question/passStates/states/QuestionPassState_Phase3';
import { QuestionPassState_Phase4 } from '../../../question/passStates/states/QuestionPassState_Phase4';
export class TopicFilter {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get topic() {
        return this.parent;
    }
    get filterQuestiontypeQuery() {
        return new APIData({
            route: `/api/personal/topic/filter/questiontype/${this.topic.id}`,
            defaultValue: [],
        });
    }
    get filterStateQuery() {
        return new APIData({
            route: `/api/personal/topic/filter/state/${this.topic.id}`,
            defaultValue: [],
        });
    }
    get filterTagQuery() {
        return new APIData({
            route: `/api/personal/topic/filter/tag/${this.topic.id}`,
            defaultValue: [],
        });
    }
    get filterQuestionQuery() {
        return new APIData({
            route: `/api/personal/topic/filter/question/${this.topic.id}`,
            defaultValue: [],
        });
    }
    get latest5MicroQuestions() {
        const microQuestionStates = this.filterQuestionQuery.streamedRef;
        if (microQuestionStates.length === 0)
            return [];
        const questionIds = microQuestionStates.slice(0, 5).map(s => s.qid);
        return questionIds.map(qid => this.topic.topicMicroQuestions.microQuestionForId(qid)).filter(micro => !!micro);
    }
    get questionPassStates() {
        return [
            new QuestionPassState_New(this),
            new QuestionPassState_Wrong(this),
            new QuestionPassState_PartialCorrect(this),
            new QuestionPassState_Blocked(this),
            new QuestionPassState_Skipped(this),
            new QuestionPassState_Passed(this),
            new QuestionPassState_CorrectAfterWrong(this),
            new QuestionPassState_Passed2(this),
            new QuestionPassState_Passed3(this),
            new QuestionPassState_Phase1(this),
            new QuestionPassState_Phase2(this),
            new QuestionPassState_Phase3(this),
            new QuestionPassState_Phase4(this),
        ];
    }
    get passStateObject() {
        return this.questionPassStates.reduce((obj, passState) => {
            obj[passState.id] = passState;
            return obj;
        }, {});
    }
}
__decorate([
    memoize
], TopicFilter.prototype, "filterQuestiontypeQuery", null);
__decorate([
    memoize
], TopicFilter.prototype, "filterStateQuery", null);
__decorate([
    memoize
], TopicFilter.prototype, "filterTagQuery", null);
__decorate([
    memoize
], TopicFilter.prototype, "filterQuestionQuery", null);
__decorate([
    cachedSet
], TopicFilter.prototype, "latest5MicroQuestions", null);
__decorate([
    memoize
], TopicFilter.prototype, "questionPassStates", null);
__decorate([
    memoize
], TopicFilter.prototype, "passStateObject", null);
